import { Stack, Step, StepConnector, stepConnectorClasses, StepIconProps, StepLabel, Stepper, styled, Typography } from "@mui/material";
import { IconCheck } from "@/assets/icons";
import { background, blue, button, text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { CASE_STATUS } from "@/features/case/constants/caseStatus";
import { TCaseMatches } from "@/api/services/main/case/dtos/get-case.dto";
import { areAllCaseMatchesFailed } from "@/features/case/utils/caseStatusHelper";

type CseStepProps = {
  activeStep?: number;
  progressStatus?: number;
  caseMatches?: TCaseMatches[];
  isAllFailed?: boolean;
};

export const CaseStep: FCC<CseStepProps> = ({ activeStep = 1, progressStatus, caseMatches = [], isAllFailed: isAllFailedProp }) => {
  const allMatchesFailed = isAllFailedProp ?? areAllCaseMatchesFailed(caseMatches);
  const showRecruitmentEnded = progressStatus === CASE_STATUS.RECRUITMENT_STOPPED && allMatchesFailed;
  const stepNames = showRecruitmentEnded
    ? ["求人情報登録", "人材推薦準備中", "人材推薦中", "面接選考中", "募集終了"]
    : ["求人情報登録", "人材推薦準備中", "人材推薦中", "面接選考中", "内定", "入社待ち"];

  const adjustedActiveStep = showRecruitmentEnded ? stepNames.length : activeStep;

  const getColorTextStep = (activeStep: number, index: number) => {
    if (index === activeStep) {
      return text.primary;
    }

    if (index < activeStep) {
      return text.tertiary;
    }

    return text.secondary;
  };

  const ColorLibStepIcon = (props: StepIconProps) => {
    const { active, completed, className } = props;

    return (
      <ColorLibStepIconRoot ownerState={{ completed, active }} className={className}>
        {completed ? <IconCheck width={20} height={20} /> : props.icon}
      </ColorLibStepIconRoot>
    );
  };

  return (
    <Stack sx={{ width: "100%" }} marginX="auto" mt={4}>
      <Stepper alternativeLabel activeStep={adjustedActiveStep} connector={<ColorLibConnector />}>
        {stepNames.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorLibStepIcon}>
              <Typography variant="body14Light" color={getColorTextStep(adjustedActiveStep, index)}>
                {label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

const ColorLibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(() => ({
  backgroundColor: `${background.disable}`,
  zIndex: 1,
  color: `${text.tertiary}`,
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundColor: `${background.white}`,
        border: `4px solid ${button.primary}`,
        color: `${button.primary}`,
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundColor: `${button.primary}`,
        color: `${text.white}`,
      },
    },
  ],
}));

const ColorLibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: `${blue[80]}`,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: `${blue[80]}`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: `${background.disable}`,
    borderRadius: 1,
  },
}));
